import { Mapper } from "../../../../../core/base";
import { LocationUpdateNotificationWebEntity } from "./location-update-notification-web-entity.ts";
import { LocationWebRepositoryMapper } from "./location-web-repository-mapper";
import { JobWebRepositoryMapper } from "../../../jobs/job-web-repository/entities/job-web-repository-mapper";
import { PlanWebRepositoryMapper } from "../../../plans/plans-web-repository/entities/plan-web-repository-mapper";
import { MasterPlanWebRepositoryMapper } from "../../../master-plans/master-plan-web-repository/entities";
import { LocationUpdateNotification } from "planning-portal-library/src/lib/core/domain";

export class LocationUpdateNotificationWebRepositoryMapper extends Mapper<LocationUpdateNotificationWebEntity, LocationUpdateNotification> {

  mapFrom(param: LocationUpdateNotificationWebEntity): LocationUpdateNotification {
    return {
      tenantId: param.tenantId,
      createdAt: param.createdAt, 
      locationId: param.locationId,
      locationName: param.locationName,
      jobId: param.jobId,
      jobName: param.jobName,
      planId: param.planId,
      planName: param.planName,
      planContainerId: param.planContainerId,
      planContainerName: param.planContainerName,
      changes: param.changes
    };
  }

  mapTo(param: LocationUpdateNotification): LocationUpdateNotificationWebEntity {
    return {
      tenantId: param.tenantId,
      createdAt: param.createdAt, 
      locationId: param.locationId,
      locationName: param.locationName,
      jobId: param.jobId,
      jobName: param.jobName,
      planId: param.planId,
      planName: param.planName,
      planContainerId: param.planContainerId,
      planContainerName: param.planContainerName,
      changes: param.changes!
    };
  }
}
